import React from 'react';
import Testimonials from "../Testmonials";
import SocialOauthButtons, { buildMicrosoftOauthHref } from '../commons/auth/SocialOauthButtons';
import ShopifyAuthModal from '../commons/auth/ShopifyAuthModal';

interface SignupProps {
    deps: any;
    loading: boolean;
    error: string | null;
    showPassword: boolean;
    onTogglePassword: () => void;
    onEmailChange: (email: string) => void;
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    onShopifySubmit: (e: React.FormEvent<HTMLFormElement>) => void;
    formRef: React.RefObject<HTMLFormElement>;
}

const Signup: React.FC<SignupProps> = ({
    deps,
    loading,
    error,
    showPassword,
    onTogglePassword,
    onEmailChange,
    onSubmit,
    onShopifySubmit,
    formRef,
}) => {
    return (

        <>

        {deps.autoSignup && (
            <div id="autoSignupOverlay">
                <div>
                    <h2>We are preparing your account...</h2>
                    <div className="loading"></div>
                </div>
            </div>
        )}
            <div className={`user-verification-noty ${error ? '' : 'hide'}`}>
                <div className="content">
                    {
                        error && <>{error}</>
                    }
                </div>
            </div>

        <section className="login-main-bg">

            <div className="login-video">
                <object style={{background:"none"}} className="login-video-autoplay" id="login-img-static" type="image/svg+xml" data="https://d2p078bqz5urf7.cloudfront.net/images/login/login-bg-animation.html"></object>
            </div>

            <div id="content-container" className={`container h-100 ${error ? '' : 'mt-50'}`}>
                <div className="row h-100">
                    <div className="col-12 col-lg-5">
                        {!deps?.prefs?.isClient && <Testimonials />}
                    </div>

                    <div className="col-12 col-lg-5">
                        <div className="card form-info-card login-form-right">

                            {
                                (deps.authError)?
                                    <>
                                        <div className="panel">
                                            <a href="https://www.engagebay.com/" target="_blank"
                                               className="text-center mt-5 mb-3 d-inline-block">
                                                <img
                                                    src="https://d2p078bqz5urf7.cloudfront.net/cloud/assets/img/engagebay.png"
                                                    alt="logo" width="200" height="30"
                                                    className="logoimg in-iframe-hide"/>
                                            </a>
                                            <div className="panel-body">
                                                <div className="alert">
                                                    <div>

                                                        <div id="resendVerificatioEmailStatus"
                                                             className="xs-mb-20"></div>

                                                        <h4>Access denied!</h4>
                                                        <h5>{deps.authError}</h5>

                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>

                                    :

                                    <>
                                        <div className="form-info-header text-center pb-4 mb-2">
                                            <a href="https://www.engagebay.com/" target="_blank"
                                               className="logo-brand mb-4 d-inline-block">
                                                <img className="logoimg in-iframe-hide"
                                                     src="https://d2p078bqz5urf7.cloudfront.net/cloud/assets/img/engagebay.png"
                                                     alt="Logo"
                                                     height="32"/>
                                            </a>
                                            <h3 className="fw-500 text-dark mb-2 pb-1">Get Started for FREE</h3>
                                            <span className="text-muted fs-14">Already have an account?
                                                <a href={`${deps.appURL}login${deps.userData ? `?${deps.userData}` : ''}${deps.route ? `#${deps.route}` : ''}`}
                                                   className="auth-switch-link"> Login</a>
                                             </span>
                                        </div>

                                        <form id="loginForm" name="loginForm" method="POST"
                                              ref={formRef}
                                              onSubmit={onSubmit}>

                                            <input type='hidden' name='command' value='signup'/>

                                            <input type='hidden'
                                                   name='source_info_id'
                                                   value={deps.sourceInfoId ? deps.sourceInfoId : ""}/>


                                            <input type='hidden' name='timeZoneId' defaultValue=''/>
                                            <input type='hidden' name='referrer_domain_id' defaultValue=''/>
                                            <input type='hidden' id='referrer_url' name='referrer_url' defaultValue=''/>
                                            <input type='hidden' id='fingerprint' name='fingerprint' defaultValue=''/>
                                            <input type="hidden" id='agencyId' name="agencyId"
                                                   value={deps?.agencyId || ''}/>
                                            <input type="hidden" id='gt' name="gt"
                                                   value={deps?.gt || ''}/>
                                            <input type="hidden" id='externalTags' name="externalTags"
                                                   value={deps?.externalTags || ''}/>

                                            <div className="form-group hide">
                                                <input className="form-control" type="hidden"
                                                       name="subscriberId"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input className="form-control" type="name"
                                                       name="name" autoComplete="name" placeholder="Name"
                                                       title="Name should be between 1-30 characters in length. Both letters and numbers are allowed but it should start with a letter. Cannot contain special characters."
                                                       minLength={1} maxLength={30} required
                                                       pattern="^[a-zA-Z][a-zA-Z0-9 ]{1,30}$"
                                                />
                                            </div>

                                            <div className="form-group">
                                                <input className="form-control user-email-field" type="email"
                                                       name="email"
                                                       autoComplete="email" minLength={6} maxLength={50}
                                                       title="Enter a valid email address."
                                                       placeholder="Username (Email Address)"
                                                       required
                                                       pattern="^((([A-Za-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[ -퟿豈-﷏ﷰ-￯])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[ -퟿豈-﷏ﷰ-￯])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[ -퟿豈-﷏ﷰ-￯])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[ -퟿豈-﷏ﷰ-￯]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[ -퟿豈-﷏ﷰ-￯])|(([a-z]|\d|[ -퟿豈-﷏ﷰ-￯])([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])*([a-z]|\d|[ -퟿豈-﷏ﷰ-￯])))\.)+(([a-z]|[ -퟿豈-﷏ﷰ-￯])|(([a-z]|[ -퟿豈-﷏ﷰ-￯])([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])*([a-z]|[ -퟿豈-﷏ﷰ-￯])))$"
                                                         defaultValue={deps.email || ''}
                                                         onChange={(e) => onEmailChange(e.target.value)}
                                                />

                                                <span id="validEmail" className="validation-result"></span>
                                            </div>

                                            <div className="form-group position-relative">
                                                <input className="form-control form-control-lg toggle-password"
                                                       id="password-field"
                                                       type={showPassword ? 'text' : 'password'}
                                                       name="password" minLength={4} maxLength={25}
                                                       autoComplete="off" placeholder="Password" required/>
                                                <div
                                                    className="position-absolute top-50 end-0 translate-middle-y pe-3 cursor-pointer">
                                                    <a href="#" onClick={(e) => { e.preventDefault(); onTogglePassword(); }}
                                                       className="pwd-field-icon-underline text-decoration-none signup-eye-icon">
                                                        <svg id="eye-icon" xmlns="http://www.w3.org/2000/svg"
                                                             xmlnsXlink="http://www.w3.org/1999/xlink" version="1.1"
                                                             x="0px" y="0px"
                                                             viewBox="0 0 50 50"
                                                             enableBackground="new 0 0 50 50"
                                                             xmlSpace="preserve">
                                    <style type="text/css">
                                    </style>
                                                            <g id="view_1_">
                                            <path
                                                d="M45,25c0,0-8.8,13.6-20,13.6S5,25,5,25s8.8-13.6,20-13.6S45,25,45,25z"/>
                                                                <circle cx="25" cy="25" r="6.8"/>
                                        </g>
                                                            {!showPassword && (
                                                                <line className="st0" x1="6" y1="9.2" x2="43.5" y2="40.4"/>
                                                            )}
                                   </svg>
                                                    </a>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <input className="form-control phone-number"
                                                       type="tel" id="phone_number" name="phone_number" minLength={4}
                                                       maxLength={50}
                                                       autoComplete="off" placeholder="+91 81234 56789" required/>
                                            </div>

                                            <div className="form-group">
                                                <input className="form-control" type="url"
                                                       name="website" autoComplete="url" placeholder="Website URL"
                                                       title="Enter a valid Website URL." minLength={3} maxLength={100}
                                                       required
                                                       pattern="^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[ -퟿豈-﷏ﷰ-￯])|(([a-z]|\d|[ -퟿豈-﷏ﷰ-￯])([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])*([a-z]|\d|[ -퟿豈-﷏ﷰ-￯])))\.)+(([a-z]|[ -퟿豈-﷏ﷰ-￯])|(([a-z]|[ -퟿豈-﷏ﷰ-￯])([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])*([a-z]|[ -퟿豈-﷏ﷰ-￯])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[-]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[ -퟿豈-﷏ﷰ-￯])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$"/>
                                            </div>
                                            {(deps.plan || deps.route || deps.coupon)
                                                ? null : (
                                                    <div className="form-group">
                                                        <div className="">
                                                            <select className="form-control form-select" id="userRoute"
                                                                    name="userRoute"
                                                                    autoComplete="off" placeholder="Category" required>
                                                                <option className="d-none" value="">What are you looking
                                                                    for?
                                                                </option>
                                                                <option value="all">Marketing, Sales and Service
                                                                </option>
                                                                <option value="marketing">Marketing</option>
                                                                <option value="sales">Sales</option>
                                                                <option value="service">Service</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}

                                            <div className="d-grid pt-2">
                                                <button
                                                    className="btn btn-lg btn-primary text-uppercase login-btn login-submit"
                                                    id="accountBoxSubmitBtn" type="submit" disabled={loading}>Sign Up
                                                    <i className='fa fa-circle-o-notch fa-spin ms-1'
                                                       style={{display: loading ? '' : 'none'}}></i>
                                                </button>
                                            </div>

                                            <div className="extra-login or-divider clearfix">
                                                <span>Or</span>
                                            </div>

                                            <SocialOauthButtons
                                                mode="signup"
                                                googleHref={`${deps.appURL}oauth?${deps.gsuiteParamsString}`}
                                                microsoftHref={buildMicrosoftOauthHref(
                                                    deps.appURL || '',
                                                    deps.gsuiteParamsString,
                                                    deps.microsoftParamsString
                                                )}
                                                hideGoogle={!!deps?.prefs?.agencyId}
                                                hideMicrosoft={!!deps?.prefs?.agencyId}
                                            />

                                            {!deps?.prefs?.isClient && (
                                            <footer className="copyright pt-4 lh-lg text-muted">
                                                &#169;{new Date().getFullYear()} EngageBay, Inc. All Rights
                                                Reserved.
                                                <br/>
                                                <a href="https://www.engagebay.com/legal/privacy-policy"
                                                   target="_blank">Privacy Policy
                                                    <span className="open-new-tab-icon"></span></a>
                                            </footer>
                                            )}

                                        </form>
                                    </>
                            }


                        </div>
                    </div>

                    <ShopifyAuthModal mode="signup" onSubmit={onShopifySubmit} />
                </div>
            </div>
        </section>
        </>

);
};

export default Signup;
